import React from 'react';
import { BookOpen, Shield, Headphones, Users } from 'lucide-react';

/**
 * Компонент секции обучения и поддержки
 */
const TrainingAndSupportSection = ({ 
  formData, 
  handleInputChange, 
  errors,
  trainingIntensityLevels,
  maintenanceLevels
}) => {
  return (
    <div className="mb-6 bg-emerald-50 dark:bg-emerald-900/20 p-4 rounded-lg border border-emerald-200 dark:border-emerald-800">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <BookOpen className="w-5 h-5 mr-2 text-emerald-500" />
        Обучение и поддержка
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Интенсивность обучения */}
        <div>
          <label htmlFor="trainingIntensity" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Users className="w-4 h-4 mr-1 text-emerald-500" />
            Интенсивность обучения
          </label>
          <select
            id="trainingIntensity"
            name="trainingIntensity"
            value={formData.trainingIntensity}
            onChange={handleInputChange}
            className={`form-select w-full ${errors.trainingIntensity ? 'input-error' : ''}`}
          >
            {trainingIntensityLevels.map((level) => (
              <option key={level.id} value={level.id}>
                {level.name}
              </option>
            ))}
          </select>
          {errors.trainingIntensity && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.trainingIntensity}
            </p>
          )}
        </div>

        {/* Уровень технической поддержки */}
        <div>
          <label htmlFor="maintenanceLevel" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Shield className="w-4 h-4 mr-1 text-emerald-500" />
            Уровень технической поддержки
          </label>
          <select
            id="maintenanceLevel"
            name="maintenanceLevel"
            value={formData.maintenanceLevel}
            onChange={handleInputChange}
            className={`form-select w-full ${errors.maintenanceLevel ? 'input-error' : ''}`}
          >
            {maintenanceLevels.map((level) => (
              <option key={level.id} value={level.id}>
                {level.name}
              </option>
            ))}
          </select>
          {errors.maintenanceLevel && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.maintenanceLevel}
            </p>
          )}
        </div>

        {/* Включение поддержки после внедрения */}
        <div className="col-span-full">
          <div className="flex items-start">
            <div className="flex items-center h-5">
              <input
                id="includePostDeploymentSupport"
                name="includePostDeploymentSupport"
                type="checkbox"
                checked={formData.includePostDeploymentSupport}
                onChange={handleInputChange}
                className="form-checkbox"
              />
            </div>
            <div className="ml-3 text-sm">
              <label htmlFor="includePostDeploymentSupport" className="font-medium text-gray-700 dark:text-gray-300 flex items-center">
                <Headphones className="w-4 h-4 mr-1 text-emerald-500" />
                Включить пост-внедренческую поддержку
              </label>
              <p className="text-gray-500 dark:text-gray-400 text-xs mt-0.5">
                Техническая поддержка и консультации после завершения внедрения
              </p>
            </div>
          </div>
        </div>
        
        {/* Длительность поддержки (отображается только если включена поддержка) */}
        {formData.includePostDeploymentSupport && (
          <div className="col-span-full md:col-span-1 ml-7">
            <label htmlFor="supportDuration" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              Длительность поддержки (месяцев)
            </label>
            <input
              type="text"
              id="supportDuration"
              name="supportDuration"
              value={formData.supportDuration}
              onChange={handleInputChange}
              className={`form-input w-full ${errors.supportDuration ? 'input-error' : ''}`}
              placeholder="Например: 12"
            />
            {errors.supportDuration && (
              <p className="mt-1 text-xs text-red-500 dark:text-red-400">
                {errors.supportDuration}
              </p>
            )}
          </div>
        )}

        {/* Информационный блок об обучении и поддержке */}
        <div className="col-span-full bg-white dark:bg-gray-700/50 rounded-lg p-3 mt-2 border border-emerald-100 dark:border-emerald-900/50">
          <p className="text-sm text-gray-600 dark:text-gray-400">
            <strong className="text-emerald-600 dark:text-emerald-400">Рекомендации:</strong> Для успешного внедрения ИИ в образовательные процессы 
            критически важно обеспечить качественное обучение персонала и техническую поддержку. 
            Выбирайте интенсивность обучения в соответствии с уровнем интеграции ИИ и готовностью 
            преподавательского состава к внедрению новых технологий.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TrainingAndSupportSection;